/* ==========================================================================
   K|KASA Progressive Web App (PWA) Client Controller
   Handles app installation, iOS guides, push notification permissions
   ========================================================================== */

(function () {
  'use strict';

  var deferredInstallPrompt = null;
  var isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  var isIOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()) && !window.MSStream;

  // 1. Register Service Worker
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = window.KK_PWA_SW_URL || '/assets/kk-pwa-sw.js';
      navigator.serviceWorker
        .register(swUrl)
        .then(function (reg) {
          console.log('[K|KASA PWA] Service Worker registered with scope:', reg.scope);
        })
        .catch(function (err) {
          console.warn('[K|KASA PWA] Service Worker registration failed:', err);
        });
    });
  }

  // 2. Capture Android/Desktop beforeinstallprompt event
  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredInstallPrompt = e;
    
    // Check if dismissed recently (7 days)
    var dismissedAt = localStorage.getItem('kk_pwa_dismissed_at');
    if (!dismissedAt || (Date.now() - parseInt(dismissedAt, 10)) > 7 * 86400000) {
      setTimeout(showInstallBanner, 4000);
    }
  });

  // 3. Track successful installation
  window.addEventListener('appinstalled', function () {
    console.log('[K|KASA PWA] App was successfully installed!');
    deferredInstallPrompt = null;
    hideInstallBanner();
    localStorage.setItem('kk_pwa_installed', 'true');
  });

  // 4. Banner Display Functions
  function showInstallBanner() {
    if (isStandalone || localStorage.getItem('kk_pwa_installed') === 'true') return;
    
    var banner = document.getElementById('kk-pwa-banner');
    if (!banner) return;

    // Adapt content for iOS vs Android
    var iosGuide = banner.querySelector('.kk-pwa-banner__ios-guide');
    var androidBtn = banner.querySelector('.kk-pwa-banner__install-btn');

    if (isIOS) {
      if (iosGuide) iosGuide.style.display = 'block';
      if (androidBtn) androidBtn.style.display = 'none';
    } else {
      if (iosGuide) iosGuide.style.display = 'none';
      if (androidBtn) androidBtn.style.display = 'inline-flex';
    }

    banner.classList.add('is-visible');
  }

  function hideInstallBanner() {
    var banner = document.getElementById('kk-pwa-banner');
    if (banner) {
      banner.classList.remove('is-visible');
    }
  }

  // 5. Global API for custom triggers
  window.kkPromptPwaInstall = function () {
    if (isStandalone) {
      alert('You are already using the K|KASA app!');
      return;
    }

    if (deferredInstallPrompt) {
      deferredInstallPrompt.prompt();
      deferredInstallPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === 'accepted') {
          console.log('[K|KASA PWA] User accepted installation');
        }
        deferredInstallPrompt = null;
      });
    } else if (isIOS) {
      var modal = document.getElementById('kk-pwa-ios-modal');
      if (modal) {
        modal.style.display = 'flex';
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      } else {
        alert('To install the K|KASA app on iPhone:\n\n1. Tap the Share button at the bottom of Safari\n2. Scroll down and tap "Add to Home Screen"\n3. Tap "Add"');
      }
    } else {
      showInstallBanner();
    }
  };

  window.kkDismissPwaBanner = function () {
    hideInstallBanner();
    localStorage.setItem('kk_pwa_dismissed_at', Date.now().toString());
  };

  window.kkClosePwaIosModal = function () {
    var modal = document.getElementById('kk-pwa-ios-modal');
    if (modal) {
      modal.classList.remove('is-open');
      setTimeout(function () { modal.style.display = 'none'; }, 250);
    }
  };

  // 6. Push Notification Permission Request
  window.kkRequestPushNotification = function () {
    if (!('Notification' in window)) {
      alert('Push notifications are not supported in this browser.');
      return;
    }

    if (Notification.permission === 'granted') {
      alert('VIP notifications are already enabled!');
      return;
    }

    if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
          console.log('[K|KASA PWA] Notification permission granted!');
          // Dispatch custom event for OneSignal or custom service
          window.dispatchEvent(new CustomEvent('kk:push:granted'));
          
          if (navigator.serviceWorker && navigator.serviceWorker.ready) {
            navigator.serviceWorker.ready.then(function (reg) {
              reg.showNotification('Welcome to K | KASA VIP', {
                body: 'You are now first in line for restocks and private collection drops.',
                icon: 'https://k-kasa.com/cdn/shop/files/kasa.png?width=192&height=192&crop=center&format=png',
                badge: 'https://k-kasa.com/cdn/shop/files/kasa.png?width=192&height=192&crop=center&format=png'
              });
            });
          }
        }
      });
    }
  };

  // 7. Auto-show iOS prompt if visiting on Safari mobile after engaging with the store
  if (isIOS && !isStandalone) {
    var dismissedAt = localStorage.getItem('kk_pwa_dismissed_at');
    if (!dismissedAt || (Date.now() - parseInt(dismissedAt, 10)) > 7 * 86400000) {
      setTimeout(function () {
        showInstallBanner();
      }, 5000);
    }
  }
})();
